<template>
  <div id="app">
    <!--<img src="./assets/logo.png">-->
    <router-view/>
  </div>
</template>

<script>
  export default {
    name: 'App',
    created () {
      try {
        document.body.removeChild(document.getElementById('loader-wrapper'))
        setTimeout(() => {
          document.getElementById('app').style.display = 'block'
        }, 500)
      } catch (e) {
        console.log(e)
      }
    }
  }
</script>

<style scoped>
  #app {
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue